import React from "react";
import { Link } from "react-router-dom";
import { BsCollectionFill } from "react-icons/bs";
import { BsFillPersonFill } from "react-icons/bs";
import { MdHome } from "react-icons/md";
import { AiFillContacts } from "react-icons/ai";
import { MdSimCardDownload } from "react-icons/md";
import resume from "../../assets/documents/Eddie Gikundi CV.pdf";

import logo from "../../assets/icons/logo.svg";
// import Logo from "./icons/logo";

function Navbar(props) {
  return (
    <div className="z-50">
      <div className=" z-50 fixed bg-cool-300 text-white text-sm flex gap-x-7 px-8 h-16 w-[100vw] justify-center items-center bottom-0 rounded-t-lg xmd:text-base xmd:rounded-none  xmd:fixed xmd:top-0  xmd:justify-end xmd:items-center">
        <img
          src={logo}
          alt="logo"
          className="hidden xmd:flex w-20 absolute left-0 ml-5"
        />
        <Link
          to="/"
          className={`flex flex-col items-center mx-6 justify-evenly xmd:flex-row ${
            props.focus == "home"
              ? "text-cool-100"
              : "text-white hover:text-cool-100"
          } transition ease-in duration-200`}
        >
          <MdHome size={20} className="block" />
          <p>Home</p>
        </Link>

        <Link
          to={`${props.focus === "portfolio" ? "#" : "/portfolio"}`}
          className={`flex flex-col items-center mx-6 justify-evenly xmd:flex-row ${
            props.focus == "portfolio"
              ? "text-cool-100"
              : "text-white hover:text-cool-100"
          } transition ease-in duration-200`}
        >
          <BsCollectionFill size={20} className="mr-2" />
          <p>Portfolio</p>
        </Link>

        <Link
          to={`${props.focus === "contact" ? "#" : "/contact"}`}
          className={`flex flex-col items-center mx-6 justify-evenly xmd:flex-row ${
            props.focus == "contact"
              ? "text-cool-100"
              : "text-white hover:text-cool-100"
          } transition ease-in duration-200`}
        >
          <AiFillContacts size={20} className="mr-2" />
          <p>Contact</p>
        </Link>

        <a
          href={resume}
          target="_blank"
          className="hidden xmd:flex items-center mx-6 ml-10 border-2 py-1 px-4 hover:border-red-400 hover:text-red-400 transition ease-out duration-200"
        >
          <MdSimCardDownload size={20} className="mr-3" />
          <p>Download CV</p>
        </a>
      </div>

      <div className="z-50 xmd:hidden fixed top-0 bg-cool-300 text-white flex w-[100%] h-16 items-center justify-end">
        <img
          src={logo}
          alt="logo"
          className="flex xmd:hidden w-20 absolute left-0 ml-5"
        />

        <a
          href={resume}
          target="_blank"
          className="xmd:hidden flex items-center mx-6 mr-12 border-2 py-1 px-4 active:text-red-400 active:border-red-400 transition ease-in duration-300"
        >
          <MdSimCardDownload size={20} className="mr-3" />
          <p>Download CV</p>
        </a>
      </div>
    </div>
  );
}

export default Navbar;
